import {
  Box,
  Button,
  CircularProgress,
  Container,
  Drawer,
  FormControl, FormControlLabel, FormHelperText, Grid,
  InputLabel, MenuItem, Select, Stack, Switch, TextField, Typography
} from '@mui/material';
import { apiService } from '../../api/axiosClient'
import dayjs from "dayjs"
import moment from 'moment'
import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import DatesPicker from 'src/components/mui/datespicker'
import { fCouponNumber } from 'src/utils/formatNumber'
import NewWindow from '../../utils/newwindow'

const DialogCoupon = (props) => {
  const { couponID, show, setShow, setReload } = props;
  const [loading, setLoading] = useState(false);
  const [chk, setChk] = useState(false);
  const [coupon, setCoupon] = useState(null);
  const [daterange, setDateRange] = useState({
    startname: '사용시작',
    startdate: new Date(),
    endname: '사용종료',
    enddate: new Date(moment().add(1, 'years'))
  });

  const defaultValues = {
    cp_title: coupon?.cp_title || '',
    cp_type: coupon?.cp_type || 1,
    cp_category: coupon?.cp_category || 1,
    cp_product: coupon?.cp_product || '',
    cp_auto: coupon?.cp_auto || 1,
    cp_code: coupon?.cp_code || '',
    cp_point: coupon?.cp_point || 0,
    cp_price: coupon?.cp_price || '',
    cp_minimum: coupon?.cp_minimum || ''
  }

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue
  } = useForm({ defaultValues })

  useEffect(() => {
    if(show) {
      couponID ? getCoupon(couponID) : setCoupon(null);
    } else {
      reset(defaultValues);
    }
  }, [show])

  useEffect(() => {
    reset(defaultValues);
    setControl(coupon?.cp_type);
    coupon?.cp_start && coupon?.cp_end && setDateRange({
      ...daterange, 
      startdate: new Date(coupon?.cp_start),
      enddate: new Date(coupon?.cp_end)
    });
  }, [coupon])

  const getCoupon = (id) => {
    const fetchData = async () => {
      try {
        const response = await apiService.get(`/coupons/${id}`)
        const payload = response.data;

        setCoupon(payload.data)
      } catch (e) {
        console.error(e)
      }
    }

    fetchData();
  }

  const [hiddenAuto, setHiddenAuto] = useState(true);
  const [hiddenCode, setHiddenCode] = useState(true);
  const [hiddenProduct, setHiddenProduct] = useState(false);
  const [hiddenDate, setHiddenDate] = useState(false);
  const [searchShow, setSearchShow] = useState(false);
    
  const setControl = (val) => {
    switch(val) {
        case 2:
            setHiddenAuto(false)
            setHiddenCode(true)
            setHiddenProduct(true)
            setHiddenDate(true)
            break;
        case 3:
            setHiddenAuto(true)
            setHiddenCode(false)
            setHiddenProduct(false)
            setHiddenDate(false)
            break;
        default:
            setHiddenAuto(true)
            setHiddenCode(true)
            setHiddenProduct(false)
            setHiddenDate(false)
            break;
    }
  }

  const handleChangeType = (e) => {
    setControl(parseInt(e.target.value))
  }

  const SearchWindow = () => {
    return (
      searchShow ? (
        <NewWindow 
          url={"/find/product"} 
          title={"상품 검색"} 
          features = {{ left: '100px', top: '100px', width: '800px', height: '900px'}}
          onUnload={() => { setSearchShow(false) }} /> ) 
        : ""
    )
  }

  window.productReceiver = (skus) => {
    setValue('cp_product', skus)
  }

  const registerCoupon = async (params) => {
    try {
      await apiService.post('/coupons', params)
      toast.success('발행 되었습니다')
      setReload(reload => reload + 1)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
      setShow(false)
    }
  }

  const changeCoupon = async (params) => {
    try {
      await apiService.put(`/coupons/${coupon.cp_id}`, params)
      toast.success('수정 되었습니다')
      setReload(reload => reload + 1)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
      setShow(false)
    }
  }

  const onSubmit = (data, e) => {
    setLoading(true)

    const params = {
      "cp_type": data.cp_type,
      "cp_title": data.cp_title,
      "cp_category": data.cp_category,
      "cp_product": data.cp_product || '',
      "cp_auto": data.cp_auto || 1,
      "cp_code": data.cp_code || '',
      "cp_start": dayjs(daterange.startdate).format("YYYY-MM-DD"),
      "cp_end": dayjs(daterange.enddate).format("YYYY-MM-DD"),
      "cp_point": data.cp_price,
      "cp_price": data.cp_price,
      "cp_minimum": data.cp_minimum,
    };

    couponID ? changeCoupon(params) : registerCoupon(params);
  }

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
    }
    setShow(open);
  };

  return (
    <>
      <Drawer anchor='right' open={show} onClose={toggleDrawer(false)}>
        <Container sx={{width: '800px', pt: 8, px: '2rem !important'}}>
          <form onSubmit={handleSubmit(onSubmit)} id="cform">
              <Box sx={{ mb: 9, textAlign: 'center' }}>
                <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                  { couponID ? "쿠폰 정보" : "쿠폰 발급" }
                </Typography>
              </Box>

              <Grid container spacing={6}>                
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <Controller
                      name='cp_title'
                      control={control}
                      rules={{ required: true }}
                      defaultValue=""
                      render={({ field: { value, onChange } }) => (
                        <TextField
                          value={value}
                          label='제목'
                          id='cp_title'
                          onChange={onChange}
                          placeholder='제목을 입력해주세요'
                          error={Boolean(errors.cp_title)}
                          aria-describedby='validation-async-cp_title'
                        />
                      )}
                    />
                    {errors.cp_title && (
                      <FormHelperText sx={{ color: 'error.main' }} id='validation-async-cp_title'>
                        필수
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id='coupon_type'>쿠폰유형</InputLabel>
                    <Controller
                      name='cp_type'
                      control={control}
                      rules={{ required: true }}
                      defaultValue="1"
                      renderValue={selected => (selected.length === 0 ? '' : selected)}
                      render={({ field: { value, onChange } }) => (
                        <Select
                          label='쿠폰유형'
                          value={value}
                          onChange={(e) => {
                            onChange(e)
                            handleChangeType(e)
                          }}
                          labelId='coupon_type'
                          error={Boolean(errors.cp_type)}
                        >
                          <MenuItem key="1" value="1">다운로드</MenuItem>
                          <MenuItem key="2" value="2">자동발행</MenuItem>
                          <MenuItem key="3" value="3">수동발행</MenuItem>
                        </Select>
                      )}
                    />
                    {errors.cp_type && (
                      <FormHelperText sx={{ color: 'error.main' }} id='validation-async-cp_type'>
                        필수
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id='coupon_use'>쿠폰사용</InputLabel>
                    <Controller
                      name='cp_category'
                      control={control}
                      rules={{ required: true }}
                      defaultValue="1"
                      renderValue={selected => (selected.length === 0 ? '' : selected)}
                      render={({ field: { value, onChange } }) => (
                        <Select
                          label='쿠폰사용'
                          value={value}
                          onChange={onChange}
                          labelId='coupon_use'
                          error={Boolean(errors.cp_category)}
                        >
                          <MenuItem key="1" value="1">금액할인</MenuItem>
                          <MenuItem key="2" value="2">배송비</MenuItem>
                          <MenuItem key="3" value="3">포인트</MenuItem>
                        </Select>
                      )}
                    />
                    {errors.cp_category && (
                      <FormHelperText sx={{ color: 'error.main' }} id='validation-async-cp_category'>
                        필수
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={12} hidden={hiddenAuto}>
                  <FormControl fullWidth>
                    <InputLabel id='cp_auto'>자동발행대상</InputLabel>
                    <Controller
                      name='cp_auto'
                      control={control}
                      rules={{ required: !hiddenAuto }}
                      defaultValue=""
                      renderValue={selected => (selected.length === 0 ? '' : selected)}
                      render={({ field: { value, onChange } }) => (
                        <Select
                          label='쿠폰사용'
                          value={value}
                          onChange={onChange}
                          labelId='cp_auto'
                          error={Boolean(errors.cp_auto)}
                        >
                          <MenuItem key="1" value="1">회원가입</MenuItem>
                          <MenuItem key="2" value="2">첫주문</MenuItem>
                        </Select>
                      )}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} hidden={hiddenCode}>
                  <Stack direction="row" spacing={2} sx={{ pr: 4 }}>
                    <FormControl sx={{width: '80%'}}>
                      <Controller
                        name='cp_code'
                        control={control}
                        rules={{ required: !hiddenCode }}
                        defaultValue=""
                        render={({ field: { value, onChange } }) => (
                          <TextField
                            value={value}
                            label='쿠폰코드'
                            id='cp_code'
                            onChange={onChange}
                            placeholder='쿠폰코드을 입력해주세요'
                            error={Boolean(errors.cp_title)}
                            aria-describedby='validation-async-cp_code'
                          />
                        )}
                      />
                      {errors.cp_code && (
                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-cp_code'>
                          필수
                        </FormHelperText>
                      )}
                    </FormControl>

                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Button variant='contained' color="info" onClick={() => {
                        setValue('cp_code', fCouponNumber())
                      }}> 자동발생 </Button>
                    </Box>
                  </Stack>
                </Grid>

                <Grid item xs={12} hidden={hiddenProduct}>
                  <Stack direction="row" spacing={2} sx={{ pr: 4 }}>
                    <FormControl disabled sx={{width: '70%'}}>
                      <Controller
                        name='cp_product'
                        control={control}
                        rules={{ required: !hiddenProduct }}
                        defaultValue=""
                        render={({ field: { value, onChange } }) => (
                          <TextField
                            disabled={Boolean(value == 'ALL')} 
                            value={value}
                            label='상품코드'
                            id='cp_product'
                            onChange={onChange}
                            placeholder='상품코드을 입력해주세요'
                            error={Boolean(errors.cp_title)}                          
                            aria-describedby='validation-async-cp_product'
                            variant='standard'
                          />
                        )}
                      />
                      {errors.cp_product && (
                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-cp_product'>
                          필수
                        </FormHelperText>
                      )}
                    </FormControl>

                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Button variant='contained' color="warning" disabled={chk} onClick={() => {setSearchShow(true)}}> 검색 </Button>
                    </Box>

                    <FormControlLabel control={<Switch defaultChecked={chk} onChange={(e) => {
                      if(e.target.checked) {
                        setValue('cp_product', 'ALL');
                        setChk(true);
                      } else {
                        setValue('cp_product', '');
                        setChk(false);
                      }
                    }} />} label="모든 상품" />
                  </Stack>
                </Grid>

                <Grid item xs={12} hidden={hiddenDate}>
                  <DatesPicker daterange={daterange} setDateRange={setDateRange} />
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <Controller
                      name='cp_price'
                      control={control}
                      rules={{ required: true }}
                      defaultValue=""
                      render={({ field: { value, onChange } }) => (
                        <TextField
                          value={value}
                          label='최대할인금액 혹은 충전포인트'
                          id='cp_price'
                          type="number"
                          onChange={onChange}
                          placeholder='최대 할인금액(포인트)을 입력해주세요'
                          error={Boolean(errors.cp_title)}
                          aria-describedby='validation-async-cp_price'
                        />
                      )}
                    />
                    {errors.cp_price && (
                      <FormHelperText sx={{ color: 'error.main' }} id='validation-async-cp_price'>
                        필수
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <Controller
                      name='cp_minimum'
                      control={control}
                      rules={{ required: true }}
                      defaultValue=""
                      render={({ field: { value, onChange } }) => (
                        <TextField
                          value={value}
                          label='최소주문금액'
                          id='cp_minimum'
                          type="number"
                          onChange={onChange}
                          placeholder='최소 주문금액을 입력해주세요'
                          error={Boolean(errors.cp_title)}
                          aria-describedby='validation-async-cp_minimum'
                        />
                      )}
                    />
                    {errors.cp_minimum && (
                      <FormHelperText sx={{ color: 'error.main' }} id='validation-async-cp_minimum'>
                        필수
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>            
          </form>

          <Stack direction="row" spacing={2} sx={{ py: 16, justifyContent: 'center' }}>
              <Button type="submit" form="cform" variant='contained'>
                  {loading ? (
                    <CircularProgress
                        sx={{
                        color: 'common.white',
                        width: '20px !important',
                        height: '20px !important',
                        mr: theme => theme.spacing(2)
                        }}
                    />
                    ) : null}
                  { couponID ? "수정" : "발행" }
              </Button>
              <Button variant='outlined' color='secondary' onClick={() => setShow(false)}> 취소 </Button>
          </Stack>
        </Container>
      </Drawer>
      <SearchWindow/>
    </>
  )
}

export default DialogCoupon
